
import { composeDecorators } from '@draft-js-plugins/editor';
import createFocusPlugin from '@draft-js-plugins/focus';
import createResizeablePlugin from '@draft-js-plugins/resizeable';
import createBlockDndPlugin from '@draft-js-plugins/drag-n-drop';
import createImagePlugin from '@draft-js-plugins/image';
import createDragNDropUploadPlugin from '@draft-js-plugins/drag-n-drop-upload';
import { CustomImageComponent } from './editorImageComponent';
import mockUpload from './mockUpload';
import '@draft-js-plugins/focus/lib/plugin.css';

const focusPlugin = createFocusPlugin();
const resizeablePlugin = createResizeablePlugin();
const blockDndPlugin = createBlockDndPlugin();

const imageDecorator = composeDecorators(
    resizeablePlugin.decorator,
    focusPlugin.decorator,
    blockDndPlugin.decorator
);

export const imagePlugin = createImagePlugin({
    decorator: imageDecorator,
    imageComponent: CustomImageComponent
});

const dragNDropFileUploadPlugin = createDragNDropUploadPlugin({
    handleUpload: mockUpload,
    addImage: imagePlugin.addImage,
});

export const editorPlugins = [
    dragNDropFileUploadPlugin,
    blockDndPlugin,
    focusPlugin,
    resizeablePlugin,
    imagePlugin,
];